// src/components/home/Hero.js
import React from 'react';
import Button from '../common/Button';
import { Link } from 'react-router-dom';

const FeatureItem = ({ icon, title, description }) => (
  <div className="flex items-center gap-3 bg-black/30 p-4 rounded-lg backdrop-blur-sm">
    <div className="w-12 h-12 rounded-full bg-primary-500/20 flex items-center justify-center flex-shrink-0">
      {icon}
    </div>
    <div>
      <h3 className="text-white font-semibold">{title}</h3>
      <p className="text-gray-300 text-sm">{description}</p>
    </div>
  </div>
);

const Hero = () => {
  const features = [
    {
      icon: (
        <svg 
          className="w-6 h-6 text-primary-400" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" 
          />
        </svg>
      ),
      title: "Najwyższa jakość",
      description: "Gwarancja czystości"
    },
    {
      icon: (
        <svg 
          className="w-6 h-6 text-primary-400" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" 
          />
        </svg>
      ),
      title: "Szybka obsługa",
      description: "Oszczędność czasu"
    },
    {
      icon: (
        <svg 
          className="w-6 h-6 text-primary-400" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" 
          />
        </svg>
      ),
      title: "Zadowolenie",
      description: "Tysiące klientów"
    }
  ];

  return (
    <section className="min-h-screen pb-20 flex items-center">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl pt-20">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Auto detailing i ręczna myjnia samochodowa
            <span className="block mt-2 text-primary-400">
              w Gdańsku
            </span>
          </h1>
          <h2 className="text-lg md:text-xl text-gray-300 mb-6">
            Pranie i naprawa tapicerki samochodowej, renowacja skór, czyszczenie wnętrza.
            Ignacego Matuszewskiego 11A, Gdańsk.
          </h2>

          <p className="text-lg md:text-xl text-gray-200 mb-8 bg-black/30 p-4 rounded-lg backdrop-blur-sm">
            Auto Kosmetyka to ręczna myjnia samochodowa w Gdańsku z usługami auto detailingu.
            Wykonujemy pranie i czyszczenie tapicerki samochodowej, naprawę tapicerki,
            renowację skór oraz kompleksowe czyszczenie wnętrza i zewnętrza samochodu.
            Dbamy o każdy detal, stosując nowoczesne metody i wysokiej jakości środki pielęgnacyjne.
          </p>
          <p className="text-lg md:text-xl text-gray-200 mb-8 bg-black/30 p-4 rounded-lg backdrop-blur-sm">
            Szukasz myjni w Gdańsku? Mycie auta, czyszczenie wnętrza samochodu i auto detailing
            wykonujemy dokładnie i ręcznie, a efekt utrzymuje się długo. Dołącz do grona
            zadowolonych klientów, którzy cenią profesjonalizm i jakość obsługi.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/services">
              <Button
                variant="primary"
                size="lg"
                className="shadow-lg w-full sm:w-auto"
              >
                Sprawdź nasze usługi
              </Button>
            </Link>
            <Link to="/contact">
              <Button
                variant="outline-white"
                size="lg"
                className="shadow-lg w-full sm:w-auto"
              >
                Umów wizytę
              </Button>
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {features.map((feature, index) => (
              <FeatureItem
                key={index}
                icon={feature.icon}
                title={feature.title}
                description={feature.description}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
